import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useSettings } from '../hooks/useSettings';

const PASSPORT_SCRIPT =
  'https://teuteuf-web-components.pages.dev/teuteuf-passport-offer.js';
const PASSPORT_TAG = 'teuteuf-passport-offer';

if (
  typeof document !== 'undefined' &&
  !customElements.get(PASSPORT_TAG) &&
  !document.querySelector('script[data-teuteuf-passport-offer]') &&
  !document.querySelector('link[data-teuteuf-passport-offer-preload]')
) {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'script';
  link.href = PASSPORT_SCRIPT;
  link.dataset.teuteufPassportOfferPreload = '';

  document.head.appendChild(link);
}

export const PassportOffer = () => {
  const { i18n } = useTranslation();
  const [settings] = useSettings();

  useEffect(() => {
    if (
      customElements.get(PASSPORT_TAG) ||
      document.querySelector('script[data-teuteuf-passport-offer]')
    ) {
      return;
    }

    const script = document.createElement('script');
    script.src = PASSPORT_SCRIPT;
    script.async = true;
    script.dataset.teuteufPassportOffer = '';
    script.onerror = () => {
      console.error('Failed to load the passport offer web component');
      script.remove();
    };

    document.head.appendChild(script);
  }, []);

  const locale = (i18n.language || 'en').split('-')[0];
  const theme = settings?.theme || 'auto';
  const referer = 'flagle';
  const redirectUrl = 'https://www.flagle.io/paymentreturn';
  const loginHref = '/account';

  return React.createElement(PASSPORT_TAG, {
    locale,
    theme,
    referer,
    redirectUrl,
    loginHref,
  });
};
